import React from "react";
import { Container, Row, Col } from "shards-react";
import PolicyAudit from "../components/contracts/policies/audit";

const PolicyAuditTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <PolicyAudit /> 
      </Col>
    </Row>
   </Container>
);

export default PolicyAuditTable;
